<script setup lang="ts">
import { ESection } from '@/components/base/Email'
import EmailBlockWrapper from './EmailBlockWrapper.vue'
import EmailSpacerToolbar from './EmailSpacerToolbar.vue'
import type { SpacerBlock } from '../../types'

const { t } = useI18n()

defineProps<{
  block: SpacerBlock
  isSelected: boolean
  colorPresets?: { color: string; label: string }[]
}>()

const emit = defineEmits<{
  (e: 'select'): void
  (e: 'update:block', block: SpacerBlock): void
}>()
</script>

<template>
  <EmailBlockWrapper
    :is-selected="isSelected"
    :label="t('pages.email.emailTemplateCreatePage.blockSpacer')"
    cursor="pointer"
    :block-background-color="block.blockBackgroundColor"
    @select="emit('select')"
  >
    <ESection :style="{ height: `${block.height}px` }" />
  </EmailBlockWrapper>
  <EmailSpacerToolbar
    v-if="isSelected"
    :block="block"
    :color-presets="colorPresets"
    @update:block="emit('update:block', $event)"
  />
</template>
